import React, { Component } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as Common from "../CommonControlls/CommonJs";

import home from "../../images/LeftMenueLogo/dashboard.png";
import home_Active from "../../images/LeftMenueLogo/dashboard_Active.png";

import dashboard from "../../images/LeftMenueLogo/dashboard.png";
import dashboard_Active from "../../images/LeftMenueLogo/dashboard_Active.png";

import district from "../../images/LeftMenueLogo/district.png";

import xpertSite from "../../images/LeftMenueLogo/xpertSite.png";
import xpertSite_Active from "../../images/LeftMenueLogo/xpertSite_Active.png";

import hcf from "../../images/LeftMenueLogo/hcf.png";
import hcf_Active from "../../images/LeftMenueLogo/hcf_Active.png";

import user from "../../images/LeftMenueLogo/user.png";
import user_Active from "../../images/LeftMenueLogo/user_Active.png";

import patient from "../../images/LeftMenueLogo/patient.png";
import patient_Active from "../../images/LeftMenueLogo/patient_Active.png";

import sample from "../../images/LeftMenueLogo/sample.png";
import sample_Active from "../../images/LeftMenueLogo/sample_Active.png";

import qrCode from "../../images/LeftMenueLogo/qrCode.png";
import qrCode_Active from "../../images/LeftMenueLogo/qrCode_Active.png";

import setting from "../../images/LeftMenueLogo/setting.png";
import setting_Active from "../../images/LeftMenueLogo/setting_Active.png";

import cluster from "../../images/LeftMenueLogo/cluster.png";
import cluster_Active from "../../images/LeftMenueLogo/cluster_Active.png";

import job from "../../images/LeftMenueLogo/job.png";
import job_Active from "../../images/LeftMenueLogo/job_Active.png";

import globe from "../../images/LeftMenueLogo/globe.png";
import globe_Active from "../../images/LeftMenueLogo/globe_Active.png";

const mapStateToProps = (state) => {
	return state;
};

class MainLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			permissions: [],
		};
	}

	componentDidMount() {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter((p) => p.permissioN_ALLOWED)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
	}

	render() {
		return (
			<aside id="left-panel" className="left-panel">
				<nav
					className="navbar navbar-expand-sm navbar-default Animated_Scroll"
					style={{ width: "100%" }}
				>
					<div
						id="main-menu"
						className="main-menu collapse navbar-collapse"
						style={{ width: "100%" }}
					>
						<ul className="nav navbar-nav">
							
						<li id="MenuLink_Dashboard" className="mainlayoutlinks activemainlink">
								<Link to="/Home">
									<span className="imageContainer d-flex justify-content-center">
										<img className="menu-icon basic_image" src={home} />
										<img
											className="menu-icon active_image"
											style={{ display: "none" }}
											src={home_Active}
										/>
									</span>
									{/* <i className="menu-icon fa fa-tachometer mainlayoutlinks"></i> */}
									<span className="MenuLabelContainer">Home</span>
								</Link>
							</li>
							<li id="MenuLink_Dashboard" className="mainlayoutlinks">
								<Link to="/Dashboard">
									<span className="imageContainer d-flex justify-content-center">
									<i className="menu-icon fa fa-tachometer mainlayoutlinks" style={{ fontSize: '25px' }}></i> 
									</span>
									{/* <i className="menu-icon fa fa-tachometer mainlayoutlinks"></i> */}
									<span className="MenuLabelContainer">Dashboard</span>
								</Link>
							</li>
							{/*<li id="MenuLink_Dashboard2" className="mainlayoutlinks">*/}
							{/*	<Link to="/Dashboard2">*/}
							{/*		<span className="imageContainer d-flex justify-content-center">*/}
							{/*			<i className="menu-icon fa fa-tachometer mainlayoutlinks" style={{ fontSize: '25px' }}></i>*/}
							{/*		</span>*/}
							{/*		*/}{/* <i className="menu-icon fa fa-tachometer mainlayoutlinks"></i> */}
							{/*		<span className="MenuLabelContainer">Dashboard2</span>*/}
							{/*	</Link>*/}
							{/*</li>*/}
							{!this.state.permissions.includes("province-view") &&
							!this.state.permissions.includes("district-view") &&
							!this.state.permissions.includes("tehsil-view") ? null : (
								<li
									id="MenuParentLink_Geography"
									className="menu-item-has-children dropdown"
								>
									<a
										href="#"
										className="dropdown-toggle"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image " src={globe} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={globe_Active}
											/>
										</span>
										<span className="MenuLabelContainer">Geography</span>
									</a>

									<ul className="sub-menu children dropdown-menu">
										{this.state.permissions.includes("province-view") && (
											<li id="MenuLink_Province" className="mainlayoutlinks">
												<Link to="/Province">Province</Link>
											</li>
										)}
										{this.state.permissions.includes("subrecipient-view") && (
											<li id="MenuLink_Sr" className="mainlayoutlinks">
												<Link to="/SubRecipient_List">Sub Recipient</Link>
											</li>
										)}
										{this.state.permissions.includes("district-view") && (
											<li id="MenuLink_Districts" className="mainlayoutlinks">
												<Link to="/Districts">Districts</Link>
											</li>
										)}
										{this.state.permissions.includes("tehsil-view") && (
											<li id="MenuLink_Tehsil" className="mainlayoutlinks">
												<Link to="/Tehsil">Tehsil</Link>
											</li>
										)}
									</ul>
								</li>
							)}

							<li
								hidden={
									this.props.UserAuthentication.UserInfo?.roleId == 1
										? false
										: true
								}
								id="MenuParentLink_Security"
								className="menu-item-has-children dropdown"
							>
								<a
									href="#"
									className="dropdown-toggle"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<span className="imageContainer d-flex justify-content-center">
										<img className="menu-icon basic_image" src={user} />
										<img
											className="menu-icon active_image"
											style={{ display: "none" }}
											src={user_Active}
										/>
									</span>
									<span className="MenuLabelContainer">Roles</span>
								</a>

								<ul className="sub-menu children dropdown-menu">
									<li id="MenuLink_Roles" className="mainlayoutlinks">
										<Link to="/Roles">Role Types</Link>
									</li>

									<li id="MenuLink_Administrator" className="mainlayoutlinks">
										<Link to="/Administrators">Administrators</Link>
									</li>
								</ul>
							</li>

							<li
								hidden={
									this.props.UserAuthentication.UserInfo?.roleId == 1
										? false
										: true
								}
								id="MenuParentLink_Finance"
								className="menu-item-has-children dropdown"
							>
								<a
									href="#"
									className="dropdown-toggle"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<span className="imageContainer d-flex justify-content-center">
										<img className="menu-icon basic_image" src={user} />
										<img
											className="menu-icon active_image"
											style={{ display: "none" }}
											src={user_Active}
										/>
									</span>
									<span className="MenuLabelContainer">Finance</span>
								</a>

								<ul className="sub-menu children dropdown-menu">
									<li id="MenuLink_RiderIncentives" className="mainlayoutlinks">
										<Link to="/RiderIncentives">Rider Incentives</Link>
									</li>

									<li id="MenuLink_RiderPayments" className="mainlayoutlinks">
										<Link to="/RiderPayments">Rider Payments</Link>
									</li>

									<li id="MenuLink_HcfIncentives" className="mainlayoutlinks">
										<Link to="/HcfIncentives">Hcf Incentives</Link>
									</li>

									<li id="MenuLink_HcfPayments" className="mainlayoutlinks">
										<Link to="/HcfPayments">Hcf Payments</Link>
									</li>
								</ul>
							</li>

							<li id="MenuLink_XpertSites" className="mainlayoutlinks">
								{this.state.permissions.includes("xpertsite-view") && (
									<Link to="/Xpert_Sites">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={xpertSite} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={xpertSite_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-medkit mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Xpert Sites</span>
									</Link>
								)}
							</li>

							<li id="MenuParentLink_HeatMap" className="mainlayoutlinks">
								{this.state.permissions.includes("heatmap") && (
									<Link to="/Heat_Map">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={user} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={user_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-medkit mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Heat Map</span>
									</Link>
								)}
							</li>

							<li id="MenuParentLink_Dispute" className=" mainlayoutlinks">
								{this.state.permissions.includes("dispute-view") && (
									<Link to="/Dispute_List">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image " src={globe} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={globe_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-medkit mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Dispute</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_DistrictWiseTarget" className="mainlayoutlinks">
								{this.state.permissions.includes(
									"districtwisetargets-view"
								) && (
									<Link to="/DistrictWise_Target">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={cluster} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={cluster_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-medkit mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">
											District Wise Targets
										</span>
									</Link>
								)}
							</li>

							{/*<li id="MenuLink_AssignedDFSRiders" className="mainlayoutlinks">*/}

							{/*    <Link to="/AssignedDFS_Riders">*/}
							{/*            <span className="imageContainer d-flex justify-content-center">*/}
							{/*               <img className="menu-icon basic_image" src={user}/>*/}
							{/*                <img className="menu-icon active_image" style={{display: "none"}}*/}
							{/*                     src={user_Active}/>*/}
							{/*            </span>*/}
							{/*        /!* <i className="menu-icon fa fa-medkit mainlayoutlinks"></i> *!/*/}
							{/*        <span className="MenuLabelContainer">Assigned DFS Riders</span>*/}
							{/*    </Link>*/}
							{/*</li>*/}

							<li id="MenuLink_HCFs" className="mainlayoutlinks">
								{this.state.permissions.includes("hcfs-view") && (
									<Link to="/BHUAndRHC">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={hcf} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={hcf_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-hospital-o mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">
											HCFs (BHUs & RHCs)
										</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_HCFClusters" className="mainlayoutlinks">
								{this.state.permissions.includes("bhusrhcscluster-view") && (
									<Link to="/BHUAndRHCClusters">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={cluster} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={cluster_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-users mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">
											BHUs & RHCs Cluster
										</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_Patients" className="mainlayoutlinks">
								{this.state.permissions.includes("patient-view") && (
									<Link to="/Patients">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={patient} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={patient_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-user mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Patients</span>
									</Link>
								)}
							</li>

							{/*<li id="MenuLink_SamplesToReceive" className="mainlayoutlinks">*/}
							{/*    {this.state.permissions.includes("patientsamples-view") &&*/}
							{/*        <Link to="/Samples_To_Receive">*/}
							{/*            <span className="imageContainer d-flex justify-content-center">*/}
							{/*                <img className="menu-icon basic_image" src={sample}/>*/}
							{/*                <img className="menu-icon active_image" style={{display: "none"}}*/}
							{/*                     src={sample_Active}/>*/}
							{/*            </span>*/}
							{/*            /!* <i className="menu-icon fa fa-ambulance mainlayoutlinks"></i> *!/*/}
							{/*            <span className="MenuLabelContainer">Patient Samples</span>*/}
							{/*        </Link>*/}
							{/*    }*/}
							{/*</li>*/}

							<li id="MenuLink_PatientSamples" className="mainlayoutlinks">
								{this.state.permissions.includes("patientsamples-view") && (
									<Link to="/Patient_Samples">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={sample} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={sample_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-tint mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Patient Samples</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_Assignments" className="mainlayoutlinks">
								{this.state.permissions.includes("jobhistory-view") && (
									<Link to="/Jobs">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={job} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={job_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-tint mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Rider Jobs</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_QRCodePrinting" className="mainlayoutlinks">
								{this.state.permissions.includes("qrcode") && (
									<Link to="/Sample_QRCode_Printing">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={qrCode} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={qrCode_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-qrcode mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">QR Codes</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_Users" className="mainlayoutlinks">
								{this.state.permissions.includes("users-view") && (
									<Link to="/Users">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={user} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={user_Active}
											/>
										</span>
										{/* <i className="menu-icon fa fa-user mainlayoutlinks"></i> */}
										<span className="MenuLabelContainer">Users</span>
									</Link>
								)}
							</li>

							{/* ---------------- Security------------ */}
							{/* <li id="MenuParentLink_Security" className="menu-item-has-children dropdown">
                                <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i className="menu-icon fa fa-shield"></i>Security</a>
                                <ul className="sub-menu children dropdown-menu">
                                        
                                    <li id="MenuLink_Users" className="mainlayoutlinks">
                                        <Link to="/Users" >Users</Link>
                                    </li>

                                    <li id="MenuLink_Roles" className="mainlayoutlinks">
                                        <Link to="/Roles">Roles</Link>
                                    </li>

                                </ul>
                            </li> */}
							<li id="MenuLink_Activity" className="mainlayoutlinks">
								{this.state.permissions.includes("activity") && (
									<Link to="/Activity_List">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={job} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={job_Active}
											/>
										</span>
										<span className="MenuLabelContainer">Activity</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_Settings" className="mainlayoutlinks">
								{this.state.permissions.includes("setting") && (
									<Link to="/Settings">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={setting} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={setting_Active}
											/>
										</span>
										<span className="MenuLabelContainer">Settings</span>
									</Link>
								)}
							</li>

							<li id="MenuLink_HelpDesk" className="mainlayoutlinks">
								{this.state.permissions.includes("setting") && (
									<Link to="/HelpDesk">
										<span className="imageContainer d-flex justify-content-center">
											<img className="menu-icon basic_image" src={setting} />
											<img
												className="menu-icon active_image"
												style={{ display: "none" }}
												src={setting_Active}
											/>
										</span>
										<span className="MenuLabelContainer">Help Desk</span>
									</Link>
								)}
							</li>

							<li
								hidden={
									this.props.UserAuthentication.UserInfo?.roleId == 1
										? false
										: true
								}
								id="MenuParentLink_Security"
								className="menu-item-has-children dropdown"
							>
								<a
									href="#"
									className="dropdown-toggle"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<span className="imageContainer d-flex justify-content-center">
										<img className="menu-icon basic_image" src={user} />
										<img
											className="menu-icon active_image"
											style={{ display: "none" }}
											src={user_Active}
										/>
									</span>
									<span className="MenuLabelContainer">Reports</span>
								</a>

								<ul className="sub-menu children dropdown-menu">
									{this.state.permissions.includes(
										"st_progress_report_Province"
									) && (
										<li id="MenuLink_Province_Report" className="mainlayoutlinks">
											<Link to="/Province_Report">Province</Link>
										</li>
									)}

									{this.state.permissions.includes("st_progress_report_sr") && (
										<li id="MenuLink_SR_Report" className="mainlayoutlinks">
											<Link to="/SR_Report">SR</Link>
										</li>
									)}

									{this.state.permissions.includes(
										"st_progress_report_district"
									) && (
										<li id="MenuLink_District_Report" className="mainlayoutlinks">
											<Link to="/District_Report">District</Link>
										</li>
									)}
								</ul>
							</li>
						</ul>
					</div>
				</nav>

				{/* right footer div */}
				{/* <div className="rightfooterdiv">
                    <div className="d-flex justify-content-center" style={{marginTop:"5px"}}>
                        <span>Copyright &copy; 2020</span><br/>             
                    </div>
                    <div className="d-flex justify-content-center">
                        <span><a style={{color:"rgba(255, 255, 255, 0.8)"}} href="https://ideacentricity.biz"> Idea Centricity</a></span>      
                    </div>
                </div> */}
			</aside>
		);
	}

	LogOut = () => {
		localStorage.clear();
		window.location.href = "/";
	};
	ResetImages = () => {
		$("#MenuLink_Dashboard > a > span > img").attr("src", dashboard);
		$("#MenuLink_Districts > a > span > img").attr("src", district);
		$("#MenuLink_XpertSites > a > span > img").attr("src", xpertSite);
		$("#MenuLink_HCFs > a > span > img").attr("src", hcf);
		$("#MenuLink_HCFClusters > a > span > img").attr("src", cluster);
		$("#MenuLink_Settings > a > span > img").attr("src", setting);
		$("#MenuLink_Users > a > span > img").attr("src", user);
		$("#MenuLink_Patients > a > span > img").attr("src", patient);
		$("#MenuLink_PatientSamples > a > span > img").attr("src", sample);
		$("#MenuLink_SamplesToReceive > a > span > img").attr("src", sample);
		$("#MenuLink_QRCodePrinting > a > span > img").attr("src", qrCode);
		$("#MenuParentLink_Geography > a > span > img").attr("src", globe);
	};
}

export default connect(mapStateToProps)(MainLayout);
